module.exports = __webpack_public_path__ + "img/book6.12bfca0b.jpg";